import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.uiState || initialState;

export const selectUiState = createSelector([selectSlice], state => state);

export const selectIsSidebarOpen = createSelector(
  [selectSlice],
  state => state.isSidebarOpen,
);

export const selectCurrentSection = createSelector(
  [selectSlice],
  state => state.currentSection,
);
